<template>
  <rabbey-base-drawer
    ref="drawerNavNav"
    title="Diferencia de equipos entre Navision y Navixy"
    size="80%"
    :drawer="drawer"
    v-on:update:drawer="$emit('update:drawer', $event)"
  >
    <el-row>
      <el-col>
        <rabbey-table3
          :columns="columns"
          :data="itemsRender"
          :summary-method="getSummaries"
          show-summary
          default-expand-all
          stripe
        ></rabbey-table3>
      </el-col>
    </el-row>
    <!-- row-key="RowIndex" -->
    <!-- <contractDetails ref="contractNavisionDetails" />
    <equimentNavixyDetails ref="equimentNavixyDetails" /> -->
    <el-button type="primary" icon="el-icon-download" @click="exportReport"
      >Exportar</el-button
    >
  </rabbey-base-drawer>
</template>

<script>
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import groupBy from "lodash/fp/groupBy";
import TagDiferenciaNav from "@/components/functionals/TagDiferenciaNav.vue";
// import contractDetails from "@/components/customers/TableContractsNav.vue";
// import equimentNavixyDetails from "@/components/customers/TableEquimentNav.vue";
// import HyperLink from "@/components/functionals/HyperLinkContract.vue";
import { exportExcel } from "@/helpers/exportExcel";

export default {
  name: "DifNavisionNavixy",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    items: Array
  },
  // components: {
  //   contractDetails,
  //   equimentNavixyDetails
  // },
  data() {
    return {
      columns: [
        {
          prop: "CustomerCode",
          label: "Código Cliente",
          width: 155,
          fixed: true
        },
        {
          prop: "CustomerName",
          label: "Nombre Cliente",
          minWidth: 150,
          fixed: true,
          sortable: true
        },
        {
          prop: "ContractNumber",
          label: "Número Contrato",
          minWidth: 150,
          fixed: true,
          sortable: true
        },
        {
          prop: "NavixyUserCode",
          label: "Código Navixy",
          minWidth: 150,
          fixed: true,
          sortable: true
        },
        {
          prop: "ContractLineQty",
          label: "Qty Lineas Navision",
          minWidth: 150,
          // cellAtrrs: {
          //   tbl: "table",
          //   OpenSelect: this.OpenSelect
          // },
          // formatter: HyperLink,
          sortable: true
        },
        {
          prop: "TrackerQty",
          label: "Qty Lineas Navixy",
          minWidth: 150,
          // cellAtrrs: {
          //   tbl: "table",
          //   OpenSelect: this.OpenSelect
          // },
          // formatter: HyperLink,
          sortable: true
        },
        {
          prop: "Difference",
          label: "Diferencia",
          minWidth: 150,
          sortable: true,
          formatter: TagDiferenciaNav
        },
        {
          prop: "Comment",
          label: "Comentario",
          minWidth: 180,
          sortable: true
        }
      ],
      dataItems: []
    };
  },
  methods: {
    // OpenSelect(props) {
    //   if (props.column === "ContractLineQty") {
    //     this.$refs.contractNavisionDetails.show(props);
    //   } else if (props.column === "TrackerQty") {
    //     this.$refs.equimentNavixyDetails.show(props);
    //   }
    // }
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        //index: posicion del array de columnas
        //sums: total/valor en la ultima fila de la tabla
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        //Columna de Diferencia de GPS
        if (column.property === "Difference") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev - curr;
            } else {
              return prev;
            }
          }, 0);
        }
        //Columnas cantidad de gps en navision y navixy
        else if (
          column.property === "ContractLineQty" ||
          column.property === "TrackerQty"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    async exportReport() {
      this.dataItems = this.items;
      await exportExcel(
        this.columns.map((column) => {
          return column.label;
        }),
        this.dataItems.map((data) => {
          return [
            data.CustomerCode,
            data.CustomerName,
            data.ContractNumber,
            data.NavixyUserCode,
            data.ContractLineQty,
            data.TrackerQty,
            data.Difference,
            data.Comment
          ];
        }),
        "Lista de Diferencia de equipos entre Navision y Navixy"
      );
    }
  },
  computed: {
    itemsRender() {
      const items = flow(
        groupBy("CustomerCode"),
        map((records) => {
          // almacena el primer registro
          const firstRecord = records[0];
          // elimina el primer registro
          records.splice(0, 1);

          // arma el objeto agregando su children para el tree
          return {
            ...firstRecord,
            children: records
          };
        })
      )(this.items);
      return items;
    }
  }
};
</script>

<style lang="scss" scoped>
.tags span:not(:first-child) {
  margin-left: 5px;
}
.el-table .warning-row {
  background: red;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
